import { Euro, SquareMeters } from '@portals/icons';
import { useFormikContext } from 'formik';
import React, { useCallback, useMemo } from 'react';

import { EstateFilterTextField } from '../../../../../components';
import { FilterValuesProps } from '../../../../../types';

interface Props {
  label: string;
  fieldName: string;
  replaceRegex?: RegExp;
  fieldType?: 'price' | 'livingSpace' | 'default';
}

export const FilterTextField: React.FC<Props> = ({ label, fieldName, replaceRegex, fieldType = 'default' }) => {
  const { values, errors, setFieldTouched, setFieldValue, handleBlur } = useFormikContext<FilterValuesProps>();

  const computedSlotProps = useMemo(() => {
    switch (fieldType) {
      case 'price':
        return { input: { startAdornment: <Euro /> } };
      case 'livingSpace':
        return { input: { startAdornment: <SquareMeters /> } };
      default:
        return {};
    }
  }, [fieldType]);

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      let value = e.target.value;
      if (replaceRegex) {
        value = value.replace(replaceRegex, '');
      }
      setFieldTouched(fieldName, true);
      setFieldValue(fieldName, value, true);
    },
    [fieldName, replaceRegex, setFieldTouched, setFieldValue]
  );

  return (
    <EstateFilterTextField
      name={fieldName}
      label={label}
      value={values[fieldName] || ''}
      onChange={handleChange}
      onBlur={handleBlur}
      error={Boolean(errors[fieldName])}
      errorMessage={errors[fieldName]}
      slotProps={computedSlotProps}
    />
  );
};
